export default __webpack_public_path__ + "static/media/iconThirdStep.a98b673e.svg";